import { render, staticRenderFns } from "./HospitalsClinicsComponent.vue?vue&type=template&id=2f4d0334&scoped=true"
import script from "./HospitalsClinicsComponent.vue?vue&type=script&lang=js"
export * from "./HospitalsClinicsComponent.vue?vue&type=script&lang=js"
import style0 from "./HospitalsClinicsComponent.vue?vue&type=style&index=0&id=2f4d0334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4d0334",
  null
  
)

export default component.exports